fx.translations("en", {

    "Commander" : "Order",
    "Total" : "Total",
    "(hors livraison) :" : "(excluding delivery) :",
    "Votre ouvrage contient" : "Your book contains",
    "pages": "pages",
    "Sauver & Quitter" : "Save & Exit",

    "Carré" : "Square",
    "Paysage" : "Landscape",
    "Portrait" : "Portrait",

    "Rechercher" : "Search",
    "Ajouter" : "Add",
    "Modifier" : "Modify",

    "Couleur" : "Color",

    "Réglages" : "Adjust",

    "Prix" : "Price",

    "Album"  : "Album",

    "Recommandés" : "Recommended",

    "Photos" : "Pictures",
    "Modèles" : "Layouts",
    "Textes" : "Texts",
    "Fonds" : "Backgrounds",
    "Stickers" : "Stickers",

    "Chargement ..." : "Loading ...",

    "Luminosité" : "Brightness",
    "Saturation" : "Saturation",
    "Contraste" : "Contrast",

    "couverture" : "cover",

    "Ok" : "Ok",
    "OK" : "OK",

    "Cadrer" : "Crop",
    "Par défaut" : "By default",

    "$ photos": "$ pictures",

    "Vue globale" : "Global view",
    "Zoomer" : "Zoom",

    "Editeur" : "Editor",

    "Total" : "Total",
    "hors livraison" : "excluding delivery",

    "Trier par ordre d'ajout" : "Sort by added date",
    "Trier par date de photo" : "Sort chronologically",
    "Masquer les photos utilisées" : "Hide used pictures",

    "Ajouter un titre" : "Add title",
    "Ajouter du texte" : "Add text",
    "Modèles à personnaliser" : "Customizable Texts",

    "Vos Albums" : "Your books",

    "Chargement des photos" : "Loading pictures",
    "Ajouter $ photo$" : "Import $ picture$",

    // popups
    "J'ai vérifié votre album, et j'ai constaté cela :" : "I checked you book, and here what I found :",

    "Ca sera rapide ..." : "It's going to be fast...",
    "La connexion est un peu lente..." : "Internet connection might be a bit slow",
    "J'essai de nouveau..." : "I try again",
    "Encore quelques secondes..." : "Still few seconds left",
    "La connexion est trop lente..." : "Internet connection might be very slow",
    "J'insiste encore..." : "I try again",
    "On devrait y être bientôt..." : "We are almost there",
    "Je sauvegarde" : "I am saving",
    
    "Je sauvegarde votre oeuvre d'art" : "I am saving your artwork",

    "La sauvegarde a échouée !" : "Saving failed !",
    "Veuillez ré-essayer.<br>Sinon <a href='/contact' target='_blank'>contacter le service client</a>" : "Please retry.<br>Otherwise <a href='/contact' target='_blank'>contact our customer service</a>",

    "Je prépare votre création" : "I am loading your pictures",
    "Ça va être génial !" : "It's going to be fun",

    "On va créer quelque chose de beau" : "Let's make something beautiful",
    "Je m'occupe de tout" : "I'm taking care of everything",
    "Ce sera parfait !" : "It'll be perfect!",
    "Ça arrive tout de suite" : "It's coming right up",
    "Je mets tout en place" : "I'm putting everything in place",
    "Vous êtes entre de bonnes mains" : "You're in good hands",
    "Encore un petit instant..." : "Just a moment...",
    "C'est bientôt prêt" : "Almost ready",
    "J'ouvre votre création" : "I'm opening your project",
    "On reprend votre création" : "Picking up where you left off",
    "Je charge votre création" : "I'm loading your project",
    "Vous allez pouvoir continuer" : "You'll be able to continue",
    "Bon retour !" : "Welcome back!",

    "Votre album sera bientôt accessible" : "Your book will be available soon",
    "Il est en cours d'envoi vers nos imprimantes." : "It is being sent to our printers.",

    "Revenir" : "Back",
    
    "A partir de $ €" : "From $ €",
    "A partir de <strong>$€</strong>" : "From <strong>$€</strong>",

    "Quel type d'ouverture souhaitez-vous ?" : "Would you like a Layflat Book ?",
    "Ouverture normale" : "Standard",
    "Ouverture à plat" : "Layflat",
    "Choisissez la forme de votre album" : "Choose shape of your book",

    "Retour" : "Back",
    "Pages" : "Pages",
    "Nombre de photos insuffisant" : "Unsuficient number of pictures",
    "Cliquez sur Retour, et ajoutez au moins $ photo(s) pour continuer la création de votre album." : "Click on Back, and add $ pictures in order to continue creating your book.",

    "Ajoutez des photos": "Add photos",
    "photo": "photo",

    "Fermer" : "Close",
    "Sauver" : "Save",
    "Etes-vous sûre ?" : "Are you sure ?",
    "Cette photo est utilisée dans votre album.<br>Elle sera supprimée de toutes les pages ou elle apparaît." : "This picture is used in your book.<br>It will be removed from all pages where it was added.",
    
    "Je la supprime" : "I delete this picture",
    "Non" : "No",

    "En supprimant ce thème, toutes les mises en pages liées seront supprimées définitivement, et les clients n'y auront plus accès immédiatement." : "If you delete this book model, all layouts linked to this model will be deleted, customers won't have access to them anymore.",
    "Je le supprime" : "I delete this model",
    
    "Votre fichier est en cours d'import..." : "We are importing your file...",
    "Annuler" : "Cancel",

    "Je n'ai pas réussi à récupérer vos photos" : "I couldn't get your pictures",
    "Un problème technique est survenu. Veuillez essayer de nouveau dans quelques instants." : "A technical problem happened. Please do try again in few minutes.",
    "Mémoire insuffisante" : "Insufficient memory",
    "Votre navigateur rencontre un problème de mémoire insuffisante. Veuillez le redémarrer pour régler le problème." : "It looks like your device doesn't have enougth memory space. Please restart it in order to fix the problem.",
    "Ajout de vos photos..." : "Adding your pictures",
    "Import de vos photos ($)" : "Importing pictures ($)",
    "Un fichier est déjà en cours d'import" : "One file is already being imported",
    "Veuillez attendre que le premier fichier soit importé." : "Please wait until file is fully imported.",
    "Je n'ai pas pu convertir votre fichier" : "I couldn't convert your file",
    "J'ai rencontré un problème en essayant de convertir votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "I faced a problem while converting your file. Please try again, or <a href='/contact' target='_blank'>contact our customer service</a>.",
    "Ces fichiers n'ont pu être transférées" : "We couldn't upload those files",
    "Vérifiez votre connexion Internet (signal wifi faible, cable déconnecté, téléchargements en cours...), ou assurez-vous que votre fichier est encore accessible (fichier supprimé, ou disque externe déconnecté)." :  "Please make sure you internet connection is stable (weak wifi signal, disconnected cable, too many uploads or streamings...). And make sure you file is still available (file not deleted, external hard drive not disconnted).",
    "Annuler" : "Cancel",
    "Quitter" : "Quit",
    "Plus tard" : "Later",
    "Votre fichier est en cours d'import" : "Your file is being processed",
    "Je vous préviens dès que votre fichier est prêt à être utilisé." : "I will let you know as soon as your file is ready.",
    "Un problème est survenu" : "A technical problem happened",
    "Je n'ai pas pu importer votre fichier. Veuillez ré-essayer ou contacter le <a href='/contact' target='_blank'>service client</a>." :  "I couldn't process your file. Please try again, or contact our <a href='/contact' target='_blank'>customer service</a>.",
    "Je n'ai pas pu récupérer vos photos" : "I couldn't get your pictures",
    "Un problème problème technique est arrivé, vos photos n'ont pu être récupérées. Veuillez-ré-essayer ou <a href='/contact' target='_blank'>contacter notre service client</a>." :  "I faced a technical problem, your pictures couldn't be accessed. Please try again, or contact our <a href='/contact' target='_blank'>customer service</a>.",
    "Analyse de vos photos" : "Analysing your pictures",
    "Recherche des moments clés" : "Searching for key moments",
    "Création de votre album" : "Creating your picture book",
    "Votre album est prêt !" : "Your book is ready !",
    "Je n'arrive pas à récupérer votre ouvrage" : "I can\'t retrieve your creation",
    "J'ai rencontré un problème en essayant de récupérer votre ouvrage. Veuillez-ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." :  "I encountered a problem while trying to retrieve your creation. Please try again, or <a href='/contact' target='_blank'>contact our customer service</a>.",
    "Je n'ai pas pu charger les pages de votre fichier" : "I couldn't load pages from your file",
    "J'ai rencontré un problème en essayant de charger les pages de votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "A problem occured while loading pages from your file. Please try again, or <a href='/contact' target='_blank'>contact our customer service</a>.",
    "Je n'ai pas pu charger cette mise en page" : "I couldn't load this layout",
    "J'ai rencontré un problème en essayant de charger cette mise en page. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "A problem occured while loading this layout. Please try again, or <a href='/contact' target='_blank'>contact our customer service</a>.",

    "Votre album a été ouvert ailleurs" : "Your book is open on another computer",
    "Pour éviter des problèmes de sauvegarde, veuillez garder l'album ouvert dans une page seulement." : "In order to avoid any saving problem, please keep open your book only in one browser at the same time",
    
    "Une petite astuce ?" : "Quick advice ?",
    "Pour sélectionner toutes les photos d'un répertoire, pressez en même temps les touches <strong>$ et A</strong>." : "To select all pictures in a folder, push at the same time keys <strong>$ and A</strong>.",
    "Ok, c'est parti !" : "Ok, let's go !",

    "Un problème avec votre connexion Internet ?" : "A problem with your internet connection ?",
    "Notre application n'arrive pas à se connecter à nos serveurs pour sauvegarder votre travail." : "Our application can't connect to our server in order to save your work.",
    "Tentative de reconnexion..." : "Trying to connect...",

    "Ne perdez pas votre travail." : "Don't loose your work.",
    "Sauvegardez votre travail, c'est simple et gratuit!<br><br>Votre création sera conservé sans limite de temps, et vous pourrez continuer à la modifier quand vous le souhaitez." : "Save your work, it's simple and free!<br><br>Your creation will be kept without any time limit, and you can continue to edit it whenever you want.",

    "Connectez-vous" : "Login",
    "Votre email" : "Your email",
    "Votre mot de passe" : "Your password",
    "Vous ne possedez pas encore de compte ?" : "You don't have an account yet ?",
    "Se connecter" : "Login",
    "Le format de votre email est incorrect" : "Wrong email format",
    "Votre mot de passe doit contenir au moins 6 caractères" : "Your password must contain at least 6 characters",
    "Veuillez saisir votre email et mot de passe" : "Please enter your email and password",
    "Connexion" : "Login",
    "Email ou mot de passe incorrect" : "Wrong email or password",
    "Email déjà utilisé" : "Email already used",
    "Enregistrement" : "Register",
    "Mot de passe incorrect" : "Wrong password",

    "Bienvenue chez Flexilivre !" : "Welcome to Flexilivre !",
    "Créez votre album en toute tranquillité, il est sauvegardé automatiquement sur votre compte." : "Create your book simply, it will be saved automatically into your account.",

    "Sauvegarder votre ouvrage" : "Save your book",
    "Entrez votre email" : "Enter your email",
    "Choisissez votre mot de passe" : "Choose your password",
    "Vous possedez deja un compte?" : "Do you already have an account ?",
    "En poursuivant, vous acceptez lez conditions generales" : "By cliking, you accept our legal mentions",

    "Ajout impossible" : "Adding impossible",
    "Votre album photo ne peut contenir plus de $ pages." : "Your book can't contain more than $ pages.",
    "Suppression impossible" : "Removing impossible",
    "Votre album photo ne peut contenir moins de $ pages." : "Your book can't contain less than $ pages.",
    
    "Je n'arrive pas à sauvegarder votre création" : "I’m unable to save your creation",
    "J'ai rencontré un problème lors de la sauvegarde de votre création. Veuillez-ressayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "I encountered a problem while saving your creation. Please try again, or <a href='/contact' target='_blank'>contact our customer service</a>.",
    
    "Une erreur est arrivée" : "An error occured",
    "Nous n'avons pu joindre le serveur. Veuillez ré-essayer de nouveau, ou contacter <a href='/contact/' target='_blank'>notre service technique</a>" : "We couldn't reach our server. Please try again, or <a href='/contact/' target='_blank'>contact our customer service</a>.",

    "Texte de la tranche de l'album" : "Picture book slice text",
    "Texte" : "Text", 
    "Fond" : "Background",
    "Retourner" : "Flip",
    "Tourner" : "Flip",
    "Supprimer" : "Remove",
    "Supprimer ces 2 pages" : "Remove those 2 pages",

    /* theme edit */
    "Sélectionnez la thématique" : "select the thematic",
    "Choisir ces modèles" : "Choose these models",
    "Tous les modèles" : "All templates",
    "Sélectionnez un thème" : "Select a theme",

    "Ouverture impossible" : "Can't open application",
    "L'application d'édition ne peut être ouverte que depuis notre site" : "Application can be opened only from our website",
    "Retourner sur Flexilivre.com" : "Go to Flexilivre.com",

    
    // renderers
    "Photo utilisée" : "Used picture",
    "Photo sélectionnée" : "Selected picture",

    // social
    "Si rien ne ne se passe après avoir cliqué sur le bouton ci-dessus, veuillez autoriser votre navigateur à afficher les popups." : "If nothing happens after clicking on button below, please allow browser to display popups.",
    "Cliquez sur le bouton ci-dessous pour vous connectez et autoriser notre application à importer vos photos." : "Connect to your account and access to your pictures by clicking on button bellow.",

    //stage
    "Cette image n'a pu être chargée" : "This picture can't be loaded",
    "Ne placez pas visages au niveau de la séparation des pages,<br>ils risquent de ne pas se recouper parfaitement après la fabrication." : "Don't put any face in middle of book,<br>they might be cut when making this book.",
    "Votre photo n'est pas de qualité suffisante. Réduisez sa taille, ou remplacez-la par une meilleure photo." : "You picture resolution is too low. Please decrease its size or replace it with a better one.",
    "Cliquez pour personnaliser la tranche" : "Click here to customize slice text",
    "L'ajout de texte sur la tranche n'est possible qu'avec une couverture rigide, ou avec plus de 40 pages." : "Customizing slice text is possible only for Hard cover books or books with more than 40 pages",
    "Ce bloc texte est trop proche du bord. Déplacez-le ou réduisez-le pour qu'il ne soit pas coupé lors de la fabrication." : "This text is too close from border. Please move it away, or decrease its size so it won't be cut when making your book.",

    "Ajouter deux pages" : "Add two pages",
    "Chargement" : "Loading",
    "Modifier la couleur de fond" : "Modify background color",
    "Ajouter du texte" : "Add text",
    "Le logo est supprimable au moment du passage de la commande.<br><br>Par contre, le QRCode n'est pas supprimable." : "Logo can be deleted when ordering your book.<br><br>QRcode can't be deleted.",

    // data / filters
	"Recherche" : "Search",
    "Fonds utilisés" : "Used backgrounds",
    "Fonds recommandés" : "Recommended backgrounds",
    "Stickers utilisés" : "Used Stickers",
    "Stickers recommandés" : "Recommended Stickers", 
    "Aucun résultat pour" : "No result for",
    "Pages simples" : "Single pages",
    "Pages doubles" : "Double pages",
    "Normal" : "No Effect",
    "Lumière" : "Brightness",
    "Contraste" : "Contrast",
    "Couleur +" : "Colorfull",
    "Netteté" : "Neat",
    "Vieilli" : "Old",
    "Noir & Blanc" : "Black & White",
    "Sepia" : "Sepia",
    "Focus" : "Focus",
    "Vintage" : "Vintage",
    "Vintage 2" : "Vintage 2",
    "Ordre d'ajout" : "Added Sort",
    "Ordre Chronologique" : "Chronological Sort",
    "Par visage" : "Face sort",

    // data / models
    
    "L'ajout de texte sur la tranche n'est possible que si votre album contient au moins 40 pages" : "Customizing slice text is possible only if your book contains at least 40 pages",
    "L'ajout de texte sur la tranche n'est possible que : <ul><li>Sur une couverture rigide</li><li>Sur une couverture souple avec au moins 40 pages</li></ul>" : "Customizing slice text is possible only if : <ul><li>Cover is Hard</li><li>Or if Cover is soft and book contains at least 40 pages</li></ul>", 

    "Couverture Agrafée" : "Binded Cover",
    "Couverture Spirale" : "Spiral Cover",
    "Couverture Souple" : "Soft Cover",
    "Couverture Rigide" : "Hard Cover",
    "Rigide & Ouverture à plat" : "LayFlat Hard Cover",

    "Carnet Agrafé" : "Stapled Album",
    "Album Spirale" : "Spiral-bound Album",
    "Album Souple" : "Softcover Album",
    "Album Rigide" : "Hardcover Album",
    "Album Ouverture à plat" : "Lay-flat Album",

    "Petit carré" : "Small square",
    "Grand carré" : "Big square",
    "Petit paysage" : "Small landscape",
    "Grand paysage" : "Big landscape",
    "Petit portrait" : "Small portrait",
    "Grand portrait" : "Big portrait",

    "21 x 21 cm" : "21 x 21 cm",
    "30 x 30 cm" : "30 x 30 cm",
    "21 x 15 cm" : "21 x 15 cm",
    "29,7 x 21 cm" : "29,7 x 21 cm",
    "15 x 21 cm" : "15 x 21 cm",
    "21 x 29,7 cm" : "21 x 29,7 cm",

    "Votre album contient $ pages" : "Your book contains $ pages",
    "dont $ pages additionnelles (+$ €)" : "including $ extra pages (+$ €)",
    "Changer la couverture" : "Change cover",
    "Changer la taille" : "Change the size",

    "Couverture Dos" : "End Cover",
    "Couverture Face" : "Front Cover",
    "Couv." : "Cover",
    "Couverture" : "Cover",
    "Ajouter un texte" : "Add Text",
    "Ajouter un TITRE" : "Add Title",
    "Page" : "Page",
    "page" : "page",


    "- La " : "- ",
    "est vide" : "is empty",

    // data / repositories
    "Rectangle" : "Rectangle",
    "Triangle" : "Triangle",
    "Losange" : "Diamond",
    "Etoile" : "Star",
    "Cercle" : "Circle",
    "Coeur" : "Heart",
    "Polygone" : "Polygon",
    
    // --- new
    // photo renderer
    "Veuillez attendre la fin du transfer<br>pour pouvoir utiliser cette photo." : "Please do wait upload is complete<br>before to use this picture.",
    "Intérieur de couverture<br> non imprimable" : "Back Cover can't<br>be customized",
    "Votre fichier a été importé !" : "Your file was imported !",
    "Nous avons converti votre fichier en album. Veuillez vérifier qu'aucun <a href='/aide/fond-perdu/' target='_blank'>texte important ne soit trop proche des bords</a>. Il risquerai d'être coupé à la fabrication." : "We converted your file into an album. Please do check that <a href='/en/aide/fond-perdu/' target='_blank'>any important text is located near edges</a>. It will be cut when fabricating your book.",

    "Appliquer" : "Apply",

    "Appliquer à la page courante" : "Apply to current page",
    "Appliquer à toutes les pages" : "Apply to all pages",
    "Vos mises en page" : "Your layouts",

    "Votre album ne contient pas un nombre de pages multiple de 4." : "Your album does not contain a number of pages multiple of 4.",
    "Par ailleurs, votre album ne contient pas un nombre de pages multiple de 4." : "Moreover, your album does not contain a number of pages multiple of 4.",
    "Une feuille sera donc ajoutée manuellement à votre ouvrage." : "A page will be added manually to your album.",

    "Je vérifie votre création.." : "I am checking your pictures..",
    "C'est parti !" : "Let's go",

    "Ajouter une photo" : "Add a picture",
    "Déposez votre photo ici" : "Drop you picture here",

    "Choisissez la taille de votre album" : "Choose size of you book",
    "Prix : <strong>$ €</strong>" : "Price: <strong>$ €</strong>",
    "Top Vente" : "Best Seller",
    "Souhaitez-vous un format plus grand ?" : "Would you like a larger format?",
    "Souhaitez-vous sublimer votre album ?" : "Would you like to enhance your album?",
    "Sélectionnez la couverture de votre album" : "Select the cover of your album",
    "Album Rigide + Ouverture à plat" : "Hardcover + Layflat Book",
    "Indisponible<br>avec la couverture actuelle" : "Not available<br>with current cover",
    "Non disponible à cause du nombre de pages de votre album" : "Not available because of the number of pages in your album",

    "Ajoutez vos photos" : "Add your photos",
    "Sélectionnez vos photos" : "Select your pictures",

    "Sélectionnez au minimum 24 photos" : "Select at least 24 photos",

     "Ré-essayer" : "Try again",
     
     "Votre texte dépasse !" : "Your text is too long!",
     "Votre texte est trop proche du bord de la page, il risque de ne pas être imprimé totalement." : "Your text is too close to the edge of the page, it may not be fully printed.",
     "Déplacez votre texte, ou réduisez-le." : "Move or reduce your text.",

     "Nous avons converti votre fichier en album. Veuillez vérifier qu'aucun texte important ne soit trop proche des bords. Il risquerai d'être coupé à la fabrication." : "We have converted your file into an album. Please check that no important text is too close to the edges. It could be cut off during production.",     
     "Une feuille sera donc ajoutée à la fin de votre ouvrage au moment de la fabrication." : "A sheet will therefore be added to the end of your work during the manufacturing process.",


     "Je peux créer votre album pour vous !" : "I can create your album for you!",
     "Oui, c'est parti !" : "Yes, let's go!",
     "Je vais vous créer un magnifique album !" : "I will create a beautiful album for you!",
     "C'est parti" : "Here we go",
     "Je créé votre album, ca sera rapide !" : "I'm creating your album, it will be quick!",
     

     "C'est parfait !" : "It's perfect!",
     "Nous attendons la réception de vos photos pour continuer.<br/> Vous serez redirigé automatiquement." : "We are waiting to receive your photos to proceed.<br/> You will be redirected automatically.",

     "Retourner à votre album" : "Return to your album",
     "J'analyse vos photos" : "I'm analyzing your photos",
     "J'analyse vos photos ($%)" : "I'm analyzing your photos ($%)",
     "Quel titre pour votre album ?" : "Which title for your album?",

     "Choisissez une proposition ou saisissez le vôtre." : "Pick a suggestion or type your own.",

     "Le titre de votre album" : "Your album title",

     "Je cherche des idées de titre..." : "Looking for title ideas...",

     "Créer mon album" : "Create my album",

     "Le $" : "$",
     "Début $" : "Early $",

     "Été $" : "Summer $",

     "Fin $" : "Late $",

     "Année $" : "Year $",
     "Souhaitez-vous que je crée votre album photo ?" : "Would you like me to create your photo album?",
     "Composition intelligente" : "Smart composition",
     "Je crée votre album pour vous !" : "I'll put your album together!",
     "Vos photos rangées par date, posées sur des pages équilibrées. Vous n'avez plus qu'à relire." : "Your photos sorted by date, laid out on balanced pages. All that's left is a read-through.",
     "Ordre chronologique respecté" : "Chronological order kept",
     "Chaque page modifiable" : "Every page editable",
     "Prêt en quelques secondes" : "Ready in seconds",
     "Composer mon album" : "Compose my album",
     "Non merci" : "No thanks",
     "Le contenu de votre album va être remplacé" : "The contents of your album will be replaced",

     "Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album." : "Your photos will be placed in chronological order,<br>you will only have to check your album.",

     "Attention : votre contenu sera totalement remplacé." : "Warning: your content will be entirely replaced.",

     "Oui, Créez mon album" : "Yes, create my album",

     "Non, merci" : "No, thanks",

     "Je récupère vos photos" : "I am getting your photos",
     "© $" : "© $",
     "du $ au $" : "from $ to $",
     "du $ au $ $" : "from $ to $ $",
     "Une fin d'année réunis" : "Together at the end of the year",
     "Un week-end en images" : "A weekend in pictures",
     "Nos bons moments" : "Our good times",
     "Le livre de recettes" : "The recipe book",
     "Nos recettes de famille" : "Our family recipes",
     "Mes recettes" : "My recipes",
     "Moment de famille" : "Family moment",
     "Réunion de famille" : "Family reunion",
     "Fête de famille" : "Family celebration",
     "Nos compagnons" : "Our companions",
     "Mon compagnon" : "My companion",
     "Mon animal" : "My pet",
     "Nous deux" : "The two of us",
     "Toi et moi" : "You and me",
     "Notre histoire" : "Our story",
     "Nos premiers moments" : "Our first moments",
     "Bienvenue au monde" : "Welcome to the world",
     "Notre petit ange" : "Our little angel",
     "Souvenirs de voyage" : "Travel memories",
     "Carnet de voyage" : "Travel diary",
     "Oui pour la vie" : "Yes for life",
     "Notre plus beau jour" : "Our most beautiful day",
     "Notre Mariage" : "Our Wedding",
     "Joyeux anniversaire" : "Happy birthday",
     "Mon anniversaire" : "My birthday",
     "Une année de plus" : "One more year",
     "Notre soirée" : "Our night out",
     "Entre amis" : "Among friends",
     "C'était la fête" : "What a party",
     "Notre voyage" : "Our trip",
     "J'affine mes propositions ..." : "Refining my suggestions ...",
     "On feuillette vos $ photos…" : "Leafing through your $ photos…",
     "On repère les moments forts…" : "Spotting the highlights…",
     "On imagine 3 titres…" : "Writing 3 titles…",
     "C'est plus long que prévu, on y est presque…" : "This is taking longer than expected, almost there…",
     "Un instant, je place vos photos..." : "One moment, I'm placing your photos...",
     "Week-end à $" : "Weekend in $",

     "Un saut à $" : "A quick trip to $",

     "Escapade à $" : "Getaway to $",

     "Une journée à $" : "A day in $",

     "Une semaine à $" : "A week in $",

     "À la découverte de $" : "Discovering $",

     "Nos vacances à $" : "Our holiday in $",

     "Un voyage à $" : "A trip to $",

     "Les vacances de Noël à $" : "Christmas holidays in $",

     "La fin d'année à $" : "New Year in $",

     "Un été à $" : "A summer in $",

     "Notre week-end : $" : "Weekend in $",

     "Nos vacances : $" : "Our holiday in $",

     "Souvenirs : $" : "Memories of $",

     "Découverte : $" : "Discovering $",

     "Noël : $" : "Christmas in $",

     "Les fêtes : $" : "The holidays in $",

     "Un été : $" : "A summer in $",

     "Noël $" : "Christmas $",

     "Les fêtes de fin d'année" : "The holiday season",

     "Notre week-end" : "Our weekend",

     "Un week-end en famille" : "A family weekend",

     "Nos vacances" : "Our holiday",

     "Souvenirs de vacances" : "Holiday memories",

     "L'été $" : "Summer $",

     "Nos souvenirs de $" : "Our memories of $",

     "Nos plus beaux moments" : "Our best moments",
     "Un mobile" : "A mobile",
     "Votre ordinateur" : "Your computer",
     "Réseaux sociaux" : "Social networks",
     "Autre" : "Other",
     "Facebook" : "Facebook",
     "Instagram" : "Instagram",
     "Google" : "Google",
     "Fichier PDF" : "PDF File",
     "Vos Albums" : "Your Albums",

     "Connecté à Google Photos sur " : "Connected to Google Photos on",
     "Se déconnecter" : "Log out",

      //  edition
      "Zoom -" : "Zoom -",
      "Zoom +" : "Zoom +",
      "Rotation" : "Rotation",
      "Bord" : "Border",
      "Forme" : "Shape",
      "Effet" : "Effect",
      "Descendre" : "Move back",
      "Remonter" : "Move forward",
      
      "Inverser" : "Invert",
      "Gras" : "Bold",
      "Italic" : "Italic",
      
      "Gauche" : "Left",
      "Centre" : "Center",
      "Droite" : "Right",

      "Changez la couverture ou la taille votre album" : "Change the cover or size of your album",
      "J'ai compris" : "I understand",

      "Le format de fichier que vous avez sélectionné est incorrect." : "The file format you selected is incorrect.",
      "Veuillez choisir un fichier avec une extension valide (.pdf)" : "Please choose a file with a valid extension (.pdf)",

     "De $ à $ pages" : "From $ to $ pages",
     "Album $, $" : "Album $, $",
     "Pages" : "Pages",
     "A partir de $" : "From $",

     "Refaire" : "Redo",
    
     "Ajouter des photos" : "Add photos",
     "Veuillez ajouter au moins $ photos" : "At least $ photos",
    
     "Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages" : "You must have at least <span class='numPhotosLabel'>$ photos</span> to order your prints",
     "Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages" : "You must have fewer than <span class='numPhotosLabel'>$ photos</span> to order your prints",

     "Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander votre album" : "You must have at least <span class='numPhotosLabel'>$ photos</span> to order your album",
     "Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander votre album" : "You must have fewer than <span class='numPhotosLabel'>$ photos</span> to order your album",

     "Trier / filtrer vos photos" : "Sort / filter your photos",
     "Ajoutez des photos puis cliquez ici pour les placer automatiquement" : "Add photos and then click here to place them automatically",
    
     "Cliquez pour changer la taille ou la couverture" : "Click to change the size or cover",
     "Cliquez pour changer la taille de votre cadre": "Click to change the size of your frame",
     "Cliquez pour changer la taille de votre affiche": "Click to change the size of your poster",
     "Cliquez pour changer la taille" : "Click to change the size",
     "contient une zone photo vide" : "contains an empty photo area",
     "contient $ zones photo vides" : "contains $ empty photo areas",

     "Transparence" : "Transparency",

     "Vous devez ajouter au moins 24 photos" : "You must add at least 24 photos",

     "Quel type d'album souhaitez-vous créer ?" : "What type of album would you like to create?",
     "Choisissez le thème de votre album" : "Choose the theme of your album",
     "Type d'album" : "Album type",

     "Budget" : "Budget",
     "Thèmes" : "Themes",
     "Votre Album" : "Your Album",

     "Cliquez ici pour agrandir" : "Click here to enlarge",

       //----
    "Bienvenue dans votre album" : "Welcome to your album",
    
    "Voici quelques informations rapides<br>avant de commencer" : "Here are some quick information<br>before you start",
    "L'effet 3D sera appliqué lors de l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas l'effet 3D dans l'éditeur</span>" : "The 3D effect will be applied during the printing of your album.<br><br>2 pairs of 3D glasses<br>will be included in your package.<br><br><span class='blue bold'>You will not see the 3D effect in the editor</span>",
    "L'effet 3D sera appliqué lors de<br>l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas<br>l'effet 3D dans l'éditeur</span>" : "The 3D effect will be applied during<br>the printing of your album.<br><br>2 pairs of 3D glasses<br>will be included in your package.<br><br><span class='blue bold'>You will not see<br>the 3D effect in the editor</span>",
    "Choisissez bien vos photos, pour un <span class='green'>effet optimal</span>" : "Choose your photos well, for an <span class='green'>optimal effect</span>.",
    "Choisissez bien vos photos<br>pour un <span class='green'>effet optimal</span>" : "Choose your photos carefully<br>for an <span class='green'>optimal effect</span>.",
    "Arrière plan avec de la matière<br>et une profondeur raisonnable" : "Background with texture<br>and reasonable depth",
    "Sujet au<br>premier plan" : "Subject in<br>the foreground",
    "de 1 à 4<br>personnes max" : "from 1 to 4<br>people max",

    "Vue page" : "Page view",

    "Coller" : "Paste",
    "Album Blanc" : "White Album",
    "Marge de découpe" : "Cutting margin",
    "Votre album est sauvegardé !" : "Your album has been saved!",
    "A partir de maintenant, votre album est sauvegardé automatiquement." : "From now on, your album is automatically saved.",
     
    "Comment faire ?" : "How to?",
     "Entrez votre numéro de téléphone portable. Vous recevrez un sms avec le lien de l'application. Vous pourrez alors envoyer vos photos vers votre albums." :  "Enter your mobile phone number. You will receive an SMS with the link to the application. Then you can send your photos to your album.",
     "Téléphone" : "Phone",
     "numéro invalide": "invalid number",
     
     "plus rapide" :  "Faster",
     "Scannez ce QRcode pour récupérer les photos depuis votre mobile" :  "Scan this QR code to retrieve the photos from your mobile.",

    // Ajout de pages

    "Vierges": "Blank",
    "Thématiques": "Thematic",
    "Ajouter des pages": "Add pages",
    "jusqu'à $ pages ($€ par pages)": "up to $ pages ($€ per page)",
    "$ pages": "$ pages",
    "Vous avez atteint le nombre maximum de pages": "You have reached the maximum number of pages",

    // Countries
     "Afghanistan": "Afghanistan",
     "Albanie": "Albania",
     "Algérie": "Algeria",
     "Samoa Américaines": "American Samoa",
     "Andorre": "Andorra",
     "Angola": "Angola",
     "Anguilla": "Anguilla",
     "Antarctique": "Antarctica",
     "Antigua-et-Barbuda": "Antigua and Barbuda",
     "Argentine": "Argentina",
     "Arménie": "Armenia",
     "Aruba": "Aruba",
     "Australie": "Australia",
     "Autriche": "Austria",
     "Azerbaïdjan": "Azerbaijan",
     "Bahamas": "Bahamas",
     "Bahreïn": "Bahrain",
     "Bangladesh": "Bangladesh",
     "Barbade": "Barbados",
     "Bélarus": "Belarus",
     "Belgique": "Belgium",
     "Belize": "Belize",
     "Bénin": "Benin",
     "Bermudes": "Bermuda",
     "Bhoutan": "Bhutan",
     "Bolivie": "Bolivia",
     "Bosnie-Herzégovine": "Bosnia and Herzegovina",
     "Botswana": "Botswana",
     "Île Bouvet": "Bouvet Island",
     "Brésil": "Brazil",
     "Territoire britannique de l'océan Indien": "British Indian Ocean Territory",
     "Îles Vierges britanniques": "British Virgin Islands",
     "Brunei Darussalam": "Brunei Darussalam",
     "Bulgarie": "Bulgaria",
     "Burkina Faso": "Burkina Faso",
     "Burundi": "Burundi",
     "Cambodge": "Cambodia",
     "Cameroun": "Cameroon",
     "Canada": "Canada",
     "Cap-Vert": "Cape Verde",
     "Îles Caïmans": "Cayman Islands",
     "République centrafricaine": "Central African Republic",
     "Tchad": "Chad",
     "Chili": "Chile",
     "Chine": "China",
     "Île Christmas": "Christmas Island",
     "Îles Cocos (Keeling)": "Cocos (Keeling) Islands",
     "Colombie": "Colombia",
     "Comores": "Comoros",
     "Congo": "Congo",
     "République démocratique du Congo": "Democratic Republic of the Congo",
     "Îles Cook": "Cook Islands",
     "Costa Rica": "Costa Rica",
     "Croatie": "Croatia",
     "Cuba": "Cuba",
     "Chypre": "Cyprus",
     "République tchèque": "Czech Republic",
     "Danemark": "Denmark",
     "Djibouti": "Djibouti",
     "Dominique": "Dominica",
     "République dominicaine": "Dominican Republic",
     "Équateur": "Ecuador",
     "Égypte": "Egypt",
     "Salvador": "El Salvador",
     "Guinée équatoriale": "Equatorial Guinea",
     "Érythrée": "Eritrea",
     "Estonie": "Estonia",
     "Éthiopie": "Ethiopia",
     "Îles Malouines": "Falkland Islands",
     "Îles Féroé": "Faroe Islands",
     "Fidji": "Fiji",
     "Finlande": "Finland",
     "France": "France",
     "Guyane française": "French Guiana",
     "Polynésie française": "French Polynesia",
     "Terres australes françaises": "French Southern Territories",
     "Gabon": "Gabon",
     "Gambie": "Gambia",
     "Géorgie": "Georgia",
     "Allemagne": "Germany",
     "Ghana": "Ghana",
     "Gibraltar": "Gibraltar",
     "Grèce": "Greece",
     "Groenland": "Greenland",
     "Grenade": "Grenada",
     "Guadeloupe": "Guadeloupe",
     "Guam": "Guam",
     "Guatemala": "Guatemala",
     "Guernesey": "Guernsey",
     "Guinée": "Guinea",
     "Guinée-Bissau": "Guinea-Bissau",
     "Guyane": "Guyana",
     "Haïti": "Haiti",
     "Îles Heard-et-MacDonald": "Heard Island and McDonald Islands",
     "Saint-Siège (État de la Cité du Vatican)": "Holy See (Vatican City State)",
     "Honduras": "Honduras",
     "Hong Kong": "Hong Kong",
     "Hongrie": "Hungary",
     "Islande": "Iceland",
     "Inde": "India",
     "Indonésie": "Indonesia",
     "Iran": "Iran",
     "Iraq": "Iraq",
     "Irlande": "Ireland",
     "Île de Man": "Isle of Man",
     "Israël": "Israel",
     "Italie": "Italy",
     "Jamaïque": "Jamaica",
     "Japon": "Japan",
     "Jersey": "Jersey",
     "Jordanie": "Jordan",
     "Kazakhstan": "Kazakhstan",
     "Kenya": "Kenya",
     "Kiribati": "Kiribati",
     "Corée du Nord": "North Korea",
     "Corée du Sud": "South Korea",
     "Koweït": "Kuwait",
     "Kirghizistan": "Kyrgyzstan",
     "Laos": "Laos",
     "Lettonie": "Latvia",
     "Liban": "Lebanon",
     "Lesotho": "Lesotho",
     "Libéria": "Liberia",
     "Libye": "Libya",
     "Liechtenstein": "Liechtenstein",
     "Lituanie": "Lithuania",
     "Luxembourg": "Luxembourg",
     "Macao": "Macao",
     "Macédoine du Nord": "North Macedonia",
     "Madagascar": "Madagascar",
     "Malawi": "Malawi",
     "Malaisie": "Malaysia",
     "Maldives": "Maldives",
     "Mali": "Mali",
     "Malte": "Malta",
     "Îles Marshall": "Marshall Islands",
     "Martinique": "Martinique",
     "Mauritanie": "Mauritania",
     "Maurice": "Mauritius",
     "Mayotte": "Mayotte",
     "Mexique": "Mexico",
     "Micronésie": "Micronesia",
     "Moldavie": "Moldova",
     "Monaco": "Monaco",
     "Mongolie": "Mongolia",
     "Monténégro": "Montenegro",
     "Montserrat": "Montserrat",
     "Maroc": "Morocco",
     "Mozambique": "Mozambique",
     "Myanmar": "Myanmar",
     "Namibie": "Namibia",
     "Nauru": "Nauru",
     "Népal": "Nepal",
     "Pays-Bas": "Netherlands",
     "Nouvelle-Calédonie": "New Caledonia",
     "Nouvelle-Zélande": "New Zealand",
     "Nicaragua": "Nicaragua",
     "Niger": "Niger",
     "Nigeria": "Nigeria",
     "Niue": "Niue",
     "Île Norfolk": "Norfolk Island",
     "Îles Mariannes du Nord": "Northern Mariana Islands",
     "Norvège": "Norway",
     "Oman": "Oman",
     "Pakistan": "Pakistan",
     "Palaos": "Palau",
     "Palestine": "Palestine",
     "Panama": "Panama",
     "Papouasie-Nouvelle-Guinée": "Papua New Guinea",
     "Paraguay": "Paraguay",
     "Pérou": "Peru",
     "Philippines": "Philippines",
     "Îles Pitcairn": "Pitcairn Islands",
     "Pologne": "Poland",
     "Portugal": "Portugal",
     "Porto Rico": "Puerto Rico",
     "Qatar": "Qatar",
     "Réunion": "Réunion",
     "Roumanie": "Romania",
     "Russie": "Russia",
     "Rwanda": "Rwanda",
     "Saint-Barthélemy": "Saint Barthélemy",
     "Sainte-Hélène, Ascension et Tristan da Cunha": "Saint Helena, Ascension and Tristan da Cunha",
     "Saint-Christophe-et-Niévès": "Saint Kitts and Nevis",
     "Sainte-Lucie": "Saint Lucia",
     "Saint-Martin (partie française)": "Saint Martin (French part)",
     "Saint-Pierre-et-Miquelon": "Saint Pierre and Miquelon",
     "Saint-Vincent-et-les-Grenadines": "Saint Vincent and the Grenadines",
     "Samoa": "Samoa",
     "Saint-Marin": "San Marino",
     "Sao Tomé-et-Principe": "Sao Tome and Principe",
     "Arabie saoudite": "Saudi Arabia",
     "Sénégal": "Senegal",
     "Serbie": "Serbia",
     "Seychelles": "Seychelles",
     "Sierra Leone": "Sierra Leone",
     "Singapour": "Singapore",
     "Saint-Martin (partie néerlandaise)": "Sint Maarten (Dutch part)",
     "Slovaquie": "Slovakia",
     "Slovénie": "Slovenia",
     "Îles Salomon": "Solomon Islands",
     "Somalie": "Somalia",
     "Afrique du Sud": "South Africa",
     "Géorgie du Sud-et-les Îles Sandwich du Sud": "South Georgia and the South Sandwich Islands",
     "Soudan du Sud": "South Sudan",
     "Espagne": "Spain",
     "Sri Lanka": "Sri Lanka",
     "Soudan": "Sudan",
     "Suriname": "Suriname",
     "Svalbard et Île Jan Mayen": "Svalbard and Jan Mayen",
     "Eswatini": "Eswatini",
     "Suède": "Sweden",
     "Suisse": "Switzerland",
     "Syrie": "Syria",
     "Taïwan": "Taiwan",
     "Tadjikistan": "Tajikistan",
     "Tanzanie": "Tanzania",
     "Thaïlande": "Thailand",
     "Timor oriental": "Timor-Leste",
     "Togo": "Togo",
     "Tokelau": "Tokelau",
     "Tonga": "Tonga",
     "Trinité-et-Tobago": "Trinidad and Tobago",
     "Tunisie": "Tunisia",
     "Turquie": "Turkey",
     "Turkménistan": "Turkmenistan",
     "Îles Turques-et-Caïques": "Turks and Caicos Islands",
     "Tuvalu": "Tuvalu",
     "Ouganda": "Uganda",
     "Ukraine": "Ukraine",
     "Émirats arabes unis": "United Arab Emirates",
     "Royaume-Uni": "United Kingdom",
     "États-Unis": "United States",
     "Îles mineures éloignées des États-Unis": "United States Minor Outlying Islands",
     "Uruguay": "Uruguay",
     "Ouzbékistan": "Uzbekistan",
     "Vanuatu": "Vanuatu",
     "Venezuela": "Venezuela",
     "Viêt Nam": "Vietnam",
     "Îles Vierges britanniques": "British Virgin Islands",
     "Îles Vierges des États-Unis": "U.S. Virgin Islands",
     "Wallis-et-Futuna": "Wallis and Futuna",
     "Sahara occidental": "Western Sahara",
     "Yémen": "Yemen",
     "Zambie": "Zambia",
     "Zimbabwe": "Zimbabwe",

     "Vous allez recevoir un sms !" : "You will receive an SMS!",
     "Dans quelques instants, vous recevrez un sms. Cliquez sur le lien, et envoyez vos photos." : "In a few moments, you will receive an SMS. Click on the link and send your photos.",

     "Changer de Thématique" : "Switch Theme",

     "Couvertures pour votre album" : "Covers for your album",
    "Modèles pour vos pages" : "Templates for your pages",

    "Thème" : "Theme",
    "Taille" :  "Size",
    "Finition" : "Finish",

    "Un Instant ..." : "One moment..",
    "C'est presque bon !" : "It's almost ready!",
    "Je sélectionne les meilleures photos" : "I select the best photos",
    "Je créé votre histoire ..." : "I create your story...",

    "Mise en page aléatoire" : "Random page layout",
    
    "<b>$</b> vous a envoyé" : "<b>$</b> has sent you",
    "Refuser" : "Decline",
    "Voir les photos" : "View photos",
    "Vous allez perdre les photos partagées de $." : "You will lose the shared photos from $.",
    "Êtes vous sûr de vouloir quitter?" : "Are you sure you want to leave?",
    "Vous allez perdre les photos partagées de $. Êtes vous sûr de vouloir quitter?" : "You will lose the shared photos from $. Are you sure you want to leave?",
    "Sélectionnez les photos que vous souhaitez garder" : "Select the photos you want to keep",
    "Tout sélectionner ($)" : "Select all ($)",
    "Tout déselectionner ($)" : "Deselect all ($)",
    "Valider ($)" : "Confirm ($)",
    "Importer ($)" : "Import ($)",
    "Choisissez vos photos dans la fenêtre Google. Elles arriveront ici." : "Choose your photos in the Google window. They will arrive here.",
    "Vos photos" : "Your photos",
    "$ photos reçues" : "$ photos received",
    "$ sur $ photos reçues" : "$ of $ photos received",
    "Vos photos arrivent" : "Your photos are arriving",
    "Envoyez vos photos depuis votre mobile" : "Send your photos from your phone",
    "Ouvrez le lien reçu par SMS et choisissez vos photos." : "Open the link you received by text and choose your photos.",
    "En attente du téléphone" : "Waiting for your phone",
    "Nous attendons vos photos…" : "Waiting for your photos…",
    "Gardez cette page ouverte. Les photos apparaîtront ici dès leur arrivée." : "Keep this page open. Your photos will appear here as they arrive.",
    "Aucune photo reçue" : "No photos received yet",
    "Continuez l'envoi depuis votre mobile, la liste se met à jour toute seule." : "Keep sending from your phone — the list updates automatically.",
    "Réception en cours" : "Receiving",
    "Vos photos sont prêtes" : "Your photos are ready",
    "Importez-les dans votre album pour commencer la mise en page." : "Import them into your album to start laying it out.",
    "$ photos seront ajoutées à votre album" : "$ photos will be added to your album",
    "Envoi pas encore terminé" : "Upload not finished yet",
    "Vos photos arrivent encore depuis votre mobile. Importer seulement les $ photos déjà reçues ?" : "Your photos are still arriving from your phone. Import only the $ received so far?",
    "Importer $ photos" : "Import $ photos",
    "Continuer l'attente" : "Keep waiting",


    // Google Photos import (SelectPhotosPanel)
    "Importez-les pour les ajouter à votre création." : "Import them to add them to your creation.",
    "$ photos seront importées" : "$ photos will be imported",
    "Aucune photo n'a été reçue." : "No photos were received.",
    "Aucune photo n'a pu être récupérée." : "No photos could be fetched.",
    "Récupération de vos photos Google" : "Fetching your Google photos",
    "Nous les récupérons depuis Google Photos, cela peut prendre un moment." : "We are fetching them from Google Photos, this can take a moment.",
    "Connexion à Google Photos" : "Connecting to Google Photos",
    "Nous récupérons vos photos…" : "Fetching your photos…",
    "Elles sont récupérées depuis Google Photos, la liste se met à jour toute seule." : "They are being fetched from Google Photos — the list updates automatically.",
    "Récupération en cours" : "Fetching",
    "Récupération pas encore terminée" : "Fetching not finished yet",
    "La récupération des photos depuis Google n'est pas terminée. Souhaitez-vous importer seulement les $ photos affichées ?" : "Your photos are still being fetched from Google. Import only the $ shown here?",

    "Récupération des photos" : "Importing pictures",

    "Appuyez ici pour tourner les pages":"Press here to turn pages",
    "Au cas ou...":"Just in case..",
    "Vous pouvez annulez vos<br>modifications ici":"You can cancel your<br>modifications here",
    "On Commence ?":"Shall we begin ?",
    //"Choisissez la couverture<br>de votre album":"Choose the cover<br>of your album",
    "Commencez par sélectionner vos photos !" : "Start by selecting your photos!",
    "Personne":"Person",
    "Trier par personne":"Sort by person",
    "Sélectionnez vos photos depuis :":"Select your photos from :",
    "Ajouter 2 pages":"Add 2 pages",
    "Couvertures":"Covers",
    "Texte de la tranche":"Spine text",
    "Besoin de Recadrer ?":"Need to Crop ?",
    "Appuyez une seconde fois<br>sur la photo.":"Press the photo<br>a second time.",
    "Classique":"Classic",
    "Mises en page":"Layouts",
    "Images":"Images",
    "Toutes":"All",
    "Non Utilisées":"Unused",
    "Remplacer":"Replace",
    "Effets":"Effects",
    "Valider":"Confirm",
    "Zoomer/Recadrez":"Zoom/Crop",
    "Supprimer 2 pages":"Delete 2 pages",
    'Vos Creations' : 'Your Creations',

    "Corriger" : "Correct",

    "Nombre de photos insuffisant" : "Insufficient number of photos",
    "Veuillez sélectionner au minimum 24 photos." : "Please select at least 24 photos.",

    "Importez vos photos en cliquant sur le bouton ici." : "Import your photos by clicking the button here.",
    "Ajoutez une photo" : "Add a photo",
    "Appuyez sur une photo ou faîtes-la glisser vers votre page" : "Tap on a photo or drag it onto your page",

    "Quel type d'album souhaitez-vous créer?" : "What type of album would you like to create?",

    "Tirage $" : "Photo Printing $",
    "$/$ photos" : "$/$ photos",
    "$ photos" : "$ photos",

    "Nombre de photo maximum" : "Maximum number of photos",
    "Vous avez atteint le nombre maximum de photos" : "You have reached the maximum number of photos",

    "Choisissez la taille de votre cadre" : "Choose your frame size",
    "Passer": "Skip",

    "Cadre Photo": "Framed Photo",
    "Poster Photo" : "Poster",

    "Ajoutez vos photos<br>en cliquant ici" : "Add your photos<br>by clicking here",

    "Choisissez les photos<br>à ajouter à votre cadre" : "Choose the photos<br>to add to your frame",

    "Votre album n'a pas été sauvegardé. Etes-vous sûre de vouloir quitter cette page ?" : "Your album has not been saved. Are you sure you want to leave this page?",
    "ATTENTION : en quittant sans sauvegarder vous risquez de perdre un partie de votre travail. Veuillez utiliser le bouton QUITTER pour quitter en sauvegardant votre travail." : "WARNING: If you leave without saving, you may lose part of your work. Please use the EXIT button to leave and save your work.",
    
    "Aller au panier (+ $ €)": "Go to cart (+ $ €)",
    "Continuer sans cadre" : "Continue without frame",
    "Continuer sans box" : "Continue without box",

    "Et si on rajoutait un joli papier en plus ?": "How about adding a nice wrapping paper?",
    "Et pourquoi pas une box pour ranger vos photos ?": "How about a box to store your photos?",
    "Pourquoi pas un cadre autour de votre chef d'oeuvre ?": "How about a frame around your masterpiece?",

    "Pour photos 10 x 10cm" : "For 10 x 10 cm pictures",
    "Pour photos 15 x 10cm" : "For 15 x 10 cm pictures",

    "Calendrier Bureau" : "Desk Calendar",
    "Calendrier Mural" : "Wall Calendar",

     "Ajoutez vos photos, puis déplacez-les sur vos pages": "Add your photos, then move them onto your pages",
    "Choisissez le mois de démarrage de votre calendrier": "Choose the starting month of your calendar",
    "Commencer": "Start",
    "Janvier": "January",
    "Février": "February",
    "Mars": "March",
    "Avril": "April",
    "Mai": "May",
    "Juin": "June",
    "Juillet": "July",
    "Août": "August",
    "Septembre": "September",
    "Octobre": "October",
    "Novembre": "November",
    "Décembre": "December",
    "Modifiez votre évènement": "Edit your event",
    "Vos dates": "Your dates",
    "Vos dates préférées méritent une place ici : anniversaires, voyages, bons moments !": "Your favorite dates deserve a place here: birthdays, trips, good times!",
    "Ajoutez un événement en sélectionnant simplement une date dans le calendrier." : "Add an event by selecting a date in the calendar.",
    "Ajoutez une date": "Add a date",
    "Sélectionnez la date": "Select the date",
    "Entrez votre évènement": "Enter your event",
    "Modifiez votre évènement": "Edit your event",

    "Lundi": "Monday",
    "Mardi": "Tuesday",
    "Mercredi": "Wednesday",
    "Jeudi": "Thursday",
    "Vendredi": "Friday",
    "Samedi": "Saturday",
    "Dimanche": "Sunday",

    "Cliquer pour ajouter une photo" : "Click to add a photo",
    "Ajouter vos photos ici" : "Add your photos here",
    "Choisissez votre modèle<br>Puis ajouter vos photos" : "Choose your template<br>Then add your photos",

    "Votre photo n'a pu être transformée, veuillez re-éssayer dans quelques instants." : "Your photo could not be transformed, please try again in a few moments.",

    "Super photo, félicitations !" : "Great photo, congratulations !",
    "Un peu de magie..." : "A little bit of magic...",
    "Je crée votre poster..." : "I am creating your poster...",
    "On y est presque..." : "We’re almost there...",
    "C'est prêt !" : "It’s ready!",

    "De préférence une photo de portrait avec des visages visibles" : "Preferably a portrait photo with visible faces",

    "$ photos minimum" : "$ minimum photos",
    "Tirage Photo" : "Photo Print",
    "Recadrez votre photo si besoin" : "Crop your photo if needed",
    "Choisissez la finition de votre poster" : "Choose the finish of your poster",
    "A partir de" : "Starting from",

    "Choisissez la taille de votre poster" : "Choose the size of your poster",
    "Changer" : "Change",

    "Cliquez pour changer la finition" : "Click to change the finish",
    "On vous propose 4 finitions" : "We offer 4 different styles",
    "Pour la taille, on part sur quoi ?" : "which size would you like?",
    "Souhaitez-vous un cadre ?" : "Would you like a frame?",
    "A partir de" : "Starting from",

    // poster / calendar
    "Modèles pour votre affiche" : "Layouts for your poster",
    "Événements" : "Events",
    "Appuyez 2 fois sur la photo" : "Press the photo twice",
    "Recadrez ?" : "Crop ?",
    "Ajoutez un événement en sélectionnant une date dans le calendrier." : "Add an event by selecting a date in the calendar.",
    "$ photos n'ont pu être envoyées" : "$ photos couldn't be uploaded",
    "1 photo n'a pu être envoyée" : "1 photo couldn't be uploaded",
    "L'envoi n'était pas terminé quand la page a été fermée, j'ai donc retiré les tirages concernés. Ajoutez à nouveau vos photos, et gardez cette page ouverte jusqu'à la fin de l'envoi." : "The upload was not finished when the page was closed, so I removed the prints concerned. Add your photos again, and keep this page open until the upload is over.",
    "Envoi $ %" : "Uploading $ %",

    // gomme magique (shared.popups.MagicEraserPopup)
    "Gomme magique" : "Magic eraser",
    "Gommer" : "Erase",
    "Gommer un élément" : "Remove an element",
    "Comment ça marche ?" : "How does it work?",
    "Tout effacer" : "Clear all",
    "Gommer la zone" : "Erase the area",
    "Gommage…" : "Erasing…",
    "Entourez la zone à gommer : tracez un contour fermé autour de l'élément" : "Circle the area to erase: draw a closed outline around the element",
    "L'intérieur du contour sera gommé. Vous pouvez entourer une autre zone." : "The inside of the outline will be erased. You can circle another area.",
    "Ne fermez pas la fenêtre, c'est presque fini." : "Don't close the window, it's almost done.",
    "Voici le résultat. Gardez-le, ou recommencez" : "Here is the result. Keep it, or start over",
    "Entourez un élément pour le supprimer de votre photo." : "Circle an element to remove it from your photo.",
    "Recommencer" : "Start over",
    "Garder" : "Keep",
    "Avant" : "Before",
    "Après" : "After",
    "Veuillez vous reconnecter." : "Please log in again.",
    "Cette photo n'est pas accessible." : "This photo is not available.",
    "La gomme magique est momentanément indisponible." : "The magic eraser is temporarily unavailable.",
    "Cette version de la photo ne peut pas être retouchée." : "This version of the photo cannot be edited.",
    "Le tracé n'a pas pu être lu, veuillez réessayer." : "The brush strokes could not be read, please try again.",
    "Veuillez patienter une minute avant le prochain effacement." : "Please wait a minute before the next erase.",
    "Vous avez atteint la limite d'effacements pour aujourd'hui." : "You have reached today's erase limit.",
    "Le traitement prend trop de temps, veuillez réessayer." : "Processing is taking too long, please try again.",
    "L'effacement a échoué, veuillez réessayer." : "The erase failed, please try again.",

    // posters : Aperçu 3D (shared.popups.WallPreviewPopup)
    "Aperçu 3D" : "3D preview",
    "Voir votre poster sur un mur" : "See your poster on a wall",
    "Poster seul" : "Poster only",
    "Poster" : "Poster",
    "Cadre bois" : "Wooden frame",
    "Bois" : "Wood",
    "Cadre noir" : "Black frame",
    "Noir" : "Black",
    "Cadre blanc" : "White frame",
    "Blanc" : "White",
    "Salon" : "Living room",
    "Chambre" : "Bedroom",
    "Cuisine" : "Kitchen",
    "Salon avec canapé rose" : "Living room with a pink sofa",
    "Chambre avec lit et commode" : "Bedroom with a bed and a chest of drawers",
    "Cuisine au mur rose" : "Kitchen with a pink wall",
    "Poster encadré" : "Framed poster",
    "Glissez pour faire pivoter · molette pour zoomer" : "Drag to turn · scroll to zoom",
    "Molette pour zoomer" : "Scroll to zoom",
    "Vue d'ensemble" : "Overview",
    "De près" : "Close-up",
    "Dimensions" : "Dimensions",
    "Pièce" : "Room",
    "Ensemble" : "Overview",
    "Afficher les dimensions" : "Show the dimensions",
    "Préparation de l'aperçu…" : "Preparing the preview…",

    // posters : the size and finish screens, the editor's options bar
    "Les aperçus sont à la même échelle : comparez d'un coup d'œil." : "The previews are at the same scale: compare at a glance.",
    "Choisissez votre finition" : "Choose your finish",
    "Comment voulez-vous l'afficher ?" : "How would you like to display it?",
    "Aperçu avec votre photo, au format $." : "Preview with your photo, in the $ size.",
    "Le + choisi" : "Most chosen",
    "Pas disponible dans cette taille" : "Not available in this size",
    "Options du poster" : "Poster options",

    // album check before ordering (shared.panels.AlbumCheckPanel)
    "Vérification en cours…" : "Checking…",
    "Nous passons votre album en revue avant l'impression." : "We're looking over your album before printing.",
    "Votre conseillère Flexilivre" : "Your Flexilivre adviser",
    "Votre album a été vérifié" : "Your album has been checked",
    "Corriger mon album" : "Fix my album",
    "complété" : "complete",
    "Tout est parfait, votre album est prêt !" : "Everything is perfect, your album is ready!",
    "Vous y êtes presque !" : "You're almost there!",
    "Encore un petit effort !" : "Just a little more!",
    "Votre album prend forme" : "Your album is taking shape",
    "Vérification des pages" : "Checking the pages",
    "Pages remplies" : "Pages filled",
    "Nombre de pages" : "Number of pages",
    "1 zone photo vide" : "1 empty photo area",
    "$ zones photo vides" : "$ empty photo areas",
    "imprimées en blanc si vous commandez" : "printed blank if you order",
    "1 page vide" : "1 empty page",
    "$ pages vides" : "$ empty pages",
    "Une feuille sera ajoutée à la fin" : "A sheet will be added at the end",
    "le nombre de pages n'est pas un multiple de 4" : "the number of pages is not a multiple of 4",
    "Pages concernées" : "Pages concerned",
    "p. $" : "p. $",
    "$ : validé" : "$: passed",
    "$ : problème détecté" : "$: problem found",

    // first pages added (common.popups.AddPagePopup)
    "Conseillère Flexilivre" : "Flexilivre adviser",
    "Psst ! $ pages" : "Psst! $ pages",
    "Un album se fait par <strong>4 pages</strong>. Sinon, on complète avec des pages blanches lors de la fabrication." : "An album is made in sets of <strong>4 pages</strong>. Otherwise, we fill in with blank pages when it is made.",
    "OK, compris" : "OK, got it",
});
